import React, { useRef, useState, useEffect, Component } from "react"
import { Asset, Link, MediaItem } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Checked } from "../../icons"
import Slider from "react-slick"
import { RightArrow, LeftArrow, EdgeBottom1 } from "../../icons"
import AnimationButton from "./animation-button"

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return <>{this.props.children}</>
  }
}

const TitleContentCategory = ({
  title,
  richContent,
  qualityItem,
  category,
  button,
  awardIcons,
  videoEmbed,
  theme,
}) => {
  const [current, setCurrent] = useState()
  const [edgeHeight, setEdgeHeight] = useState()
  const slider = useRef()
  const edgeRef = useRef()

  const settings = {
    className: "slider variable-width",
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    fade: false,
    dots: false,
    centerMode: true,
    variableWidth: true,
    swipeToSlide: true,
    centerPadding: 0,
    autoplay: true,

    // smooth, slow, continuous scroll
    autoplaySpeed: 0,
    speed: 50000, // slower = smoother movement
    cssEase: "linear",

    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,

    beforeChange: (current, next) => {
      setCurrent(category[next])
    },
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          autoplay: false,
          speed: 500,
        },
      },
    ],
  }

  useEffect(() => {
    const idx = slider?.current?.innerSlider?.state?.currentSlide ?? 0
    if (category?.length) setCurrent(category[idx])

    const handleOffsetHeight = () => {
      setEdgeHeight(edgeRef?.current?.offsetHeight)
    }

    handleOffsetHeight()
    window.addEventListener("resize", handleOffsetHeight)
    return () => {
      window.removeEventListener("resize", handleOffsetHeight)
    }
  }, [category])

  return (
    <section className={`title-content-category ${theme}`}>
      <>
        <div
          className="title-content-category__inner"
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-easing="ease"
        >
          {title && <h2>{parse(title)}</h2>}
          {richContent && <StructuredText data={richContent} />}
          {qualityItem?.length > 0 && (
            <ul>
              {qualityItem.map((el, i) => (
                <li key={i}>
                  <span>
                    <Checked />
                  </span>
                  {el.title}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div
          className={`title-content-category__items title-content-category__items-${theme}`}
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-easing="ease"
        >
          {(theme === "edlyn" ||
            theme === "woods" ||
            theme === "sunnyside") && (
            <BlockUpdate>
              <Slider ref={slider} {...settings}>
                {category?.length > 0 &&
                  [...category, ...category, ...category, ...category].map(
                    (el, i) => (
                      <div key={i} className="title-content-category__item">
                        {el.image && (
                          <Link
                            to={`/${theme}/our-products/?category=${el.title}`}
                          >
                            <Asset asset={el.image} />
                          </Link>
                        )}
                        {el.title && (
                          <Link
                            to={`/${theme}/our-products/?category=${el.title
                              .toLowerCase()
                              .trim()
                              .split(" ")
                              .join("-")
                              .replace("-&-", "-")}`}
                            className={`btn ${
                              theme === "edlyn"
                                ? "btn--edlyn-blue"
                                : "btn--gold"
                            }`}
                          >
                            {el.title}
                          </Link>
                        )}
                      </div>
                    )
                  )}
              </Slider>
            </BlockUpdate>
          )}

          {theme === "bone" &&
            category?.length > 0 &&
            category.map((el, i) => (
              <div key={i} className="title-content-category__item">
                {el.image && <Asset asset={el.image} />}
              </div>
            ))}

          {theme === "greenwheat" && (
            <div
              className="tcvi__video"
              data-sal="slide-up"
              data-sal-duration="1000"
              data-sal-easing="ease"
            >
              {videoEmbed && (
                <MediaItem item={videoEmbed} videoThumbnail={null} />
              )}
              {awardIcons?.length > 0 && (
                <div className="title-content-category__awards">
                  {awardIcons.map((el, i) => (
                    <Asset key={i} asset={el} />
                  ))}
                </div>
              )}
            </div>
          )}

          {(theme === "edlyn" || theme === "woods") && (
            <div className="title-content-category__arrows">
              <button onClick={() => slider.current.slickPrev()}>
                <LeftArrow color="#ffffff" />
              </button>
              <button onClick={() => slider.current.slickNext()}>
                <RightArrow color="#ffffff" />
              </button>
            </div>
          )}

          {current && (theme === "edlyn" || theme === "woods") && (
            <div className="title-content-category__current">
              <Link
                to={`/${theme}/our-products/?category=${current.title}`}
                className={`btn ${
                  theme === "edlyn" ? "btn--edlyn-blue" : "btn--gold"
                }`}
              >
                {current.title}
              </Link>
            </div>
          )}
        </div>

        {(theme === "bone" || theme === "greenwheat") &&
          button?.length > 0 && (
            <div className="title-content-category__button">
              <AnimationButton
                to={
                  button[0].link[0].externalLink
                    ? button[0].link[0].externalLink
                    : button[0].link[0].internalLink?.permalink
                }
                className="btn btn--animation"
              >
                {button[0].title}
              </AnimationButton>
            </div>
          )}

        {theme === "woods" && (
          <div
            className="title-content-category__edge"
            ref={edgeRef}
            style={{ bottom: -(edgeHeight) + 5 }}
          >
            <EdgeBottom1 color="#ffffff" />
          </div>
        )}
      </>
    </section>
  )
}

export default TitleContentCategory

export const query = graphql`
  fragment TitleContentCategoryProps on DatoCmsTitleContentCategory {
    id
    title
    richContent {
      value
    }
    qualityItem {
      title
    }
    button {
      ...LinkWithTitleProps
    }
    awardIcons {
      ...InternalAssetProps
    }
    category {
      ... on DatoCmsEdlynProductCategory {
        id
        title
        image {
          ...InternalAssetProps
        }
      }
      ... on DatoCmsBoneProductCategory {
        title
        image {
          ...InternalAssetProps
        }
      }
      ... on DatoCmsGreenwheatProductCategory {
        title
        image {
          ...InternalAssetProps
        }
      }
      ... on DatoCmsSunnysideProductCategory {
        title
        image {
          ...InternalAssetProps
        }
      }
      ... on DatoCmsWoodsProductCategory {
        title
        image {
          ...InternalAssetProps
        }
      }
    }
    videoEmbed {
      ...MediaItemProps
    }
  }
`
